<template>
  <div class="modal-content">
    <div class="modal-header pt-4">
      <h5 class="modal-title">Add Document</h5>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pt-3">
      <form @submit.prevent="addDocument">
        <!-- School -->
        <div
          class="form-group"
          v-if="tokenObj.UserType == userTypeMainAdmin && !isFromUserDocument"
        >
          <label>School<span class="text-danger">*</span></label>
          <select
            v-model="schoolId"
            class="form-control"
            required
            @change="onChangeSchool($event)"
          >
            <option value>-- Select School --</option>
            <option v-for="item in schools" :value="item.Id" :key="item.Id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <!-- /School -->

        <!-- User Type -->
        <div class="form-group" v-if="!isFromUserDocument">
          <label>User Type<span class="text-danger">*</span></label>
          <select
            v-model="userType"
            class="form-control"
            required
            @change="onChangeUserType($event)"
          >
            <option value>-- Select User Type --</option>
            <option
              v-for="item in userTypes"
              :value="item.Name"
              :key="item.Name"
            >
              {{ item.Name }}
            </option>
          </select>
        </div>
        <!-- /User Type -->

        <!-- Name -->
        <div class="form-group" v-if="!isFromUserDocument">
          <label>Name<span class="text-danger">*</span></label>
          <select v-model="userId" class="form-control" required>
            <option value>-- Select User --</option>
            <option v-for="item in users" :value="item.Id" :key="item.Id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <!-- /Name -->

        <!-- Document -->
        <div class="form-group">
          <label style="line-height: 15px">
            Document<span class="text-danger">*</span>
            <span class="note">
              (Maximum file size: 5 MB. Only zip, pdf, jpg, jpeg, png, doc,
              docx, xls, xlsx are allowed)
            </span>
          </label>
          <div class="row align-items-center">
            <div :class="docFile ? 'col-11 pr-0' : 'col-12'">
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  accept=".zip,.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                  id="docFileUpload"
                  ref="docFileUpload"
                  @change="onDocSelected($event)"
                  required
                />
                <label class="custom-file-label" for="docFileUpload">
                  {{ docFileName }}
                </label>
              </div>
            </div>
            <div class="col-1" v-if="docFile">
              <a
                href="javascript:void(0)"
                id="removeDocFile"
                title="Remove Document"
                @click.prevent="removeDocFile"
              >
                <i class="fa fa-trash" style="color: grey"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- /Document -->

        <!-- Remarks -->
        <div class="form-group">
          <label>Remarks<span class="text-danger">*</span></label>
          <textarea class="form-control" v-model="remarks" required></textarea>
        </div>
        <!-- /Remarks -->

        <!-- Sent to -->
        <div class="form-group">
          <label>Send Notification To</label>
          <select
            v-if="userType == userTypeStudent"
            v-model="instructorId"
            class="form-control"
          >
            <option value>-- Select Instructor --</option>
            <option v-for="item in instructors" :value="item.Id" :key="item.Id">
              {{ item.Name }}
            </option>
          </select>
          <input
            v-else
            type="email"
            v-model="sentTo"
            class="form-control"
            placeholder="Enter Email Address Here"
          />
        </div>
        <div class="submit-section mt-4">
          <button class="btn btn-primary submit-btn">Upload</button>
        </div>
        <!-- /Sent to -->
      </form>
    </div>
  </div>
</template>


<script>
import API from "../../http-common.js";
import config from "../../config";
export default {
  props: [
    "isFromUserDocument",
    "sourceUserType",
    "sourceUserId",
    "sourceSchoolId",
  ],
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      schoolId: "",
      schools: [],
      userType: "",
      userTypes: [],
      userId: "",
      users: [],
      docFileName: "Upload Document",
      docFile: null,
      remarks: "",
      sentTo: "",
      instructorId: "",
      instructors: [],
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  methods: {
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSchool(event) {
      this.users = [];
      this.userId = "";
      this.instructors = [];
      this.instructorId = "";
      this.userTypes = [];
      this.userType = "";
      let schoolId = event.target.value;
      if (schoolId) this.getDocumentUserTypes(schoolId);
    },
    getDocumentUserTypes(schoolId) {
      API.document
        .getDocumentUserTypes({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.userTypes = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeUserType(event) {
      this.users = [];
      this.userId = "";
      this.instructors = [];
      this.instructorId = "";
      let userType = event.target.value;
      let schoolId =
        this.tokenObj.UserType == this.userTypeMainAdmin
          ? this.schoolId
          : this.tokenObj.SchoolId;
      if (schoolId) {
        if (userType == this.userTypeStudent) {
          this.getSchoolStudents(schoolId);
          this.getSchoolInstructors(schoolId);
        } else {
          this.getSchoolStaffsByUserType(schoolId);
        }
      }
    },
    getSchoolInstructors(schoolId) {
      API.school
        .getSchoolInstructors({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.instructors = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchoolStudents(schoolId) {
      API.school
        .getSchoolStudents({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.users = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchoolStaffsByUserType(schoolId) {
      API.school
        .getSchoolStaffsByUserType({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          Name: this.userType,
        })
        .then((response) => {
          if (response.data.success) {
            this.users = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    addDocument() {
      let param = {
        Token: this.tokenObj.Token,
        UserType: this.tokenObj.UserType,
        UserId: this.userId,
        File: this.docFile,
        FileName: this.docFileName,
        Remarks: this.remarks,
        SentTo: this.sentTo,
        InstructorId: this.instructorId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to upload the document?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willAdd) => {
        if (willAdd) {
          this.$store.state.isLoading = true;
          API.document
            .addDocument(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$emit("refreshData");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    //for document upload control
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    onDocSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        this.$swal("File size exceeds 5 MB", { icon: "error" });
        return;
      }
      this.docFileName = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.docFile = result;
      });
    },
    removeDocFile() {
      this.docFile = null;
      this.docFileName = "Upload Document";
      this.$refs.docFileUpload.value = null;
    },
  },
  created() {
    if (this.tokenObj.UserType == this.userTypeMainAdmin) this.getSchools();
    else this.getDocumentUserTypes(this.tokenObj.SchoolId);

    if (this.isFromUserDocument) {
      this.userType = this.sourceUserType;
      this.userId = this.sourceUserId;
      if (this.sourceUserType == this.userTypeStudent)
        this.getSchoolInstructors(this.sourceSchoolId);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Shared/DocumentAdd.vue